import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import './Factbox.scss';

function Factbox() {
  const container = useRef();

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: 'top 75%',
        end: 'top 75%',
        once: true
      }
    });
    tl.fromTo('#helpIcon', { y: 20 }, { y: 0, duration: 1 }).to('#realtor', {
      opacity: 1,
      duration: 1
    });
  }, []);

  return (
    <section className="factbox" ref={container}>
      <div className="factbox-contents">
        <svg
          id="helpIcon"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 55.78 50"
          className="factbox__icon"
        >
          <path
            className="cls-1F"
            d="M51.46,7h-17V4.29A4.21,4.21,0,0,0,30.15,0H4.4A4.21,4.21,0,0,0,.11,4.29v35.9A2.87,2.87,0,0,0,3,43.05a3,3,0,0,0,2.29-1.14l5.86-7.58h6.15V37a4.34,4.34,0,0,0,4.44,4.29H44.59l6.15,7.58a3,3,0,0,0,4.15.43,2.57,2.57,0,0,0,1-2.14V11.3A4.52,4.52,0,0,0,51.46,7Zm-41,24.46A1.77,1.77,0,0,0,9.26,32L3,40.19V4.29A1.35,1.35,0,0,1,4.4,2.86H30.15a1.35,1.35,0,0,1,1.43,1.43V7H21.71a4.34,4.34,0,0,0-4.44,4.29V31.47Z"
            transform="translate(-0.11)"
          />
          <path
            className="cls-1F"
            d="M43,19.9H40.8v9.15a.92.92,0,0,1-.85.86h-4a.38.38,0,0,1-.43-.43V23.62a.38.38,0,0,0-.43-.43H30.65a.38.38,0,0,0-.43.43v5.86a.38.38,0,0,1-.43.43h-4a.92.92,0,0,1-.86-.86V19.9H22.78c-.71,0-.86-.43-.28-.86L32.37,9.6a.9.9,0,0,1,1.28,0L43.38,19C43.81,19.61,43.66,19.9,43,19.9Z"
            transform="translate(-0.11)"
          />
          <path
            id="realtor"
            className="cls-2F"
            d="M46.45,24.17H44.3v9.15a.92.92,0,0,1-.85.86h-4a.38.38,0,0,1-.43-.43V27.89a.38.38,0,0,0-.43-.43H34.15a.38.38,0,0,0-.43.43v5.86a.38.38,0,0,1-.43.43h-4a.92.92,0,0,1-.86-.86V24.17H26.28c-.71,0-.85-.43-.28-.86l9.87-9.44a.9.9,0,0,1,1.28,0l9.73,9.44C47.31,23.88,47.17,24.17,46.45,24.17Z"
            transform="translate(-0.11)"
          />
        </svg>
        <h3 className="factbox__title">How REALTORS® can help</h3>
        <p className="factbox__copy">
          Whether you’re buying, selling, or just thinking about a move, it pays to get the best
          possible advice. The National Association of REALTORS® has 1.5 million members who are{' '}
          <a
            className="hyperLink"
            href="https://www.nar.realtor/articles/the-realtor-difference"
            target="_blank"
            rel="sponsored"
          >
            proud to call themselves REALTORS®
          </a>
          .
        </p>
        <p className="factbox__copy">
          REALTORS® serve the interests of their clients while following{' '}
          <a
            className="hyperLink"
            href="https://cdn.nar.realtor/sites/default/files/documents/2022-COE-Standards-of-Practice-2021-12-15.pdf"
            target="_blank"
            rel="sponsored"
          >
            NAR’s Code of Ethics and Standards of Practice
          </a>{' '}
          that prizes honesty, integrity, fairness, and professionalism toward all parties in a
          transaction.
        </p>
        <p className="factbox__copy">
          NAR frequently publishes insights and analysis on the state of the housing market for its
          members. REALTORS® can use this information to provide their clients with expert guidance.
        </p>
        <p className="factbox__copy">
          Buyers and sellers can use a free nationwide search tool to{' '}
          <a
            className="hyperLink"
            href="https://www.realtor.com/thats-who-we-r/"
            target="_blank"
            rel="sponsored"
          >
            Find a REALTOR®
          </a>{' '}
          with the skills, specialty certifications and designations to handle practically any real
          estate need.
        </p>
      </div>
    </section>
  );
}

export default Factbox;
